import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger.js'
import debounce from '../functions/debounce.js';

gsap.registerPlugin(ScrollTrigger)
  ; (function($) {
    'use strict'

    var About = {
      init: function() {
        // if($(".section-milestone").length > 0) {
        //   const handleResize = debounce(() => {
        //     this.milestoneSetup();
        //   },250);

        //   $(window).on('load resize',function() {
        //     handleResize()
        //   })
        // }

        if($(".section-milestone").length > 0) {
          this.milestoneNew()
        }
        this.cultureSetup()
      },

      // Milestone Setup
      milestoneSetup: function() {
        const isMobile = window.matchMedia("(max-width: 576px)").matches;

        // Cấu hình mặc định
        const tabSelector = '[data-tab-to]';
        const contentSelector = isMobile ? '.milestone-header [data-tab-content]' : '.milestone-body [data-tab-content]';

        // Lấy các elements
        const $tabs = $(tabSelector);

        console.log($tabs);
        const $contents = $(contentSelector);
        const $tabWrapper = $('.milestone-header .list-milestone');
        const $milestoneSection = $('.section-milestone');

        // Biến để lưu interval ID
        let autoPlayInterval;
        let isAutoPlayActive = false;

        // Tính toán chiều cao lớn nhất của content
        function calculateMaxContentHeight() {
          let maxHeight = 0;
          $contents.each(function() {
            const height = $(this).outerHeight();
            maxHeight = Math.max(maxHeight,height);
          });
          return maxHeight;
        }

        // Set min-height cho content container
        function setContentMinHeight() {
          const maxHeight = calculateMaxContentHeight();
          const $contentContainer = isMobile ? $('.milestone-header') : $('.milestone-body');
          $contentContainer.css('min-height',maxHeight + 'px');

          ScrollTrigger.refresh()
        }

        // Hàm xử lý khi click vào tab
        function activateTab($clickedTab) {
          const targetName = $clickedTab.attr('data-tab-to');

          // 1. Xóa trạng thái cũ
          $tabs.removeClass('current');

          // 2. Kích hoạt tab được click
          $clickedTab.addClass('current');

          // 3. Kích hoạt nội dung tương ứng
          const $targetContent = isMobile ? $(`.milestone-header [data-tab-content="${targetName}"]`) : $(`.milestone-body [data-tab-content="${targetName}"]`);

          // 4. Ẩn tất cả content và hiển thị content được chọn
          $contents.each(function() {
            const $content = $(this);
            if($content.hasClass('active')) {
              $content.removeClass('active').css({
                'display': 'none',
                'position': 'absolute',
                'opacity': 0
              });
            }
          });

          $targetContent.addClass('active').css({
            'display': 'block',
            'position': 'relative',
            'opacity': 1
          });

          // 5. Cập nhật trạng thái active cho các tab (milestone progress)
          $tabs.each(function(index) {
            const $tab = $(this);
            const currentTabIndex = $tabs.index($tabs.filter(`[data-tab-to="${targetName}"]`));

            if(index < currentTabIndex) {
              $tab.addClass('active'); // Tab đã hoàn thành (trước tab hiện tại)
            } else {
              $tab.removeClass('active');
            }
          });

          // 6. Auto scroll tab vào view
          scrollTabIntoView($clickedTab);
        }

        // Hàm auto scroll tab vào giữa màn hình
        function scrollTabIntoView($tab) {
          if(isMobile) return; // Chỉ scroll trên desktop

          const wrapperWidth = $tabWrapper.width();
          const tabPosition = $tab.position().left;
          const tabWidth = $tab.outerWidth();
          const halfScreenWidth = wrapperWidth / 2;

          // Tính toán vị trí scroll mới để tab nằm ở giữa wrapper
          let newScrollPosition = tabPosition - (wrapperWidth / 2) + (tabWidth / 2);

          // Đảm bảo không scroll quá giới hạn
          const maxScroll = $tabWrapper[0].scrollWidth - wrapperWidth;
          newScrollPosition = Math.max(0,Math.min(newScrollPosition,maxScroll));

          // Sử dụng GSAP để animation mượt mà hơn
          gsap.to($tabWrapper,{
            scrollLeft: newScrollPosition,
            duration: 0.5,
            ease: "power2.out"
          });
        }

        // Hàm xử lý auto play
        function startAutoPlay() {
          if(!isAutoPlayActive) return;

          // Clear interval cũ nếu có
          if(autoPlayInterval) {
            clearInterval(autoPlayInterval);
          }

          // Set interval mới
          autoPlayInterval = setInterval(() => {
            const $currentTab = $tabs.filter('.current');
            const $nextTab = $currentTab.next(tabSelector);

            // Nếu là tab cuối cùng thì quay lại tab đầu tiên
            if($nextTab.length === 0) {
              activateTab($tabs.first());
            } else {
              activateTab($nextTab);
            }
          },5000);
        }

        // Gắn sự kiện click cho tất cả tabs
        $tabs.on('click',function() {
          const $this = $(this);
          activateTab($this);

          // Reset auto play khi user click
          if(!isMobile) startAutoPlay();
        });

        // Kích hoạt tab mặc định
        const $defaultTab = $tabs.first();
        if($defaultTab.length > 0) {
          activateTab($defaultTab);
        }

        // Set min-height cho content container khi load và resize
        setContentMinHeight();
        $(window).on('resize',debounce(setContentMinHeight,250));

        // Scroll Observer để bắt đầu auto play khi section gần viewport
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if(entry.isIntersecting) {
              isAutoPlayActive = true;
              if(!isMobile) startAutoPlay();
            } else {
              isAutoPlayActive = false;
              if(autoPlayInterval) {
                clearInterval(autoPlayInterval);
              }
            }
          });
        },{
          threshold: 0.5 // Kích hoạt khi section hiển thị 50%
        });

        observer.observe($milestoneSection[0]);
      },

      // Culture
      cultureSetup: function() {
        const $cardsBox = $('.cards-box')
        const $cards = $('.card:not(.hide)')
        const $pagination = $('.slider-controls .pagination-line')
        const $maxSlide = $('.max-slide')
        const $activeSlide = $('.active-slide')

        if(!$cardsBox.length || !$cards.length || !$pagination.length || !$maxSlide.length || !$activeSlide.length)
          return

        // Throttle utility
        function throttle(func,limit) {
          let inThrottle = false
          return function(...args) {
            if(!inThrottle) {
              func.apply(this,args)
              inThrottle = true
              setTimeout(() => (inThrottle = false),limit)
            }
          }
        }

        const arrIndexes = Array.from({length: $cards.length},(_,i) => i)
        let hoverPreviewInterval

        // Initialize pagination
        function initPagination() {
          $pagination.empty()
          $cards.each((index) => {
            const $line = $('<span>').addClass('line')
            if(index === 0) $line.addClass('active')
            $pagination.append($line)
          })

          const total = $cards.length < 10 ? `0${$cards.length}` : $cards.length
          $maxSlide.text(total)
          $activeSlide.text('01')
        }

        // Set data-slide attributes
        function setIndex(arr) {
          $cards.each((i,card) => {
            $(card).attr('data-slide',arr[i])
          })
        }

        // Update active pagination
        function updateActivePagination() {
          const index = $cards.toArray().findIndex((card) => $(card).attr('data-slide') === '0')

          $pagination.find('.line').each((i,line) => {
            $(line).toggleClass('active',i === index)
          })

          const displayIndex = index + 1 < 10 ? `0${index + 1}` : index + 1
          $activeSlide.text(displayIndex)
        }

        // Handle click
        const handleClick = throttle(() => {
          arrIndexes.unshift(arrIndexes.pop())
          setIndex(arrIndexes)
          updateActivePagination()
        },200)

        // Hover preview
        function startHoverPreview() {
          hoverPreviewInterval = setInterval(() => $cardsBox.trigger('click'),2000)
        }

        $cardsBox.on('click',handleClick)
        $cardsBox.on('mouseenter',() => clearInterval(hoverPreviewInterval))
        $cardsBox.on('mouseleave',startHoverPreview)

        // Resize handler (if needed)
        const handleResize = throttle(() => {
          setIndex(arrIndexes)
          updateActivePagination()
        },100)
        // $(window).on('resize', handleResize);

        // Initial setup
        initPagination()
        setIndex(arrIndexes)
        // startHoverPreview()

        // Optional cleanup if needed:
        // $(window).off('resize', handleResize);
        // $cardsBox.off('click', handleClick);
      },

      // Milestone New Timeline
      milestoneNew: function() {
        // Constants and state
        const MOBILE_BREAKPOINT = 768;
        const SCROLL_TRIGGER_DELAY = 100;
        const ANIMATION_DURATION = 600;
        const PROGRESS_UPDATE_DELAY = 50;
        const HEADER_HEIGHT = 80;
        const VIEWPORT_OFFSET = 20;

        let currentIndex = 0;
        let isAnimating = false;
        const $timelineProgress = $('.timeline-progress');
        const $timelineLabels = $('.timeline-label');
        const $contentSlides = $('.content-slide');
        const $section = $('.section-milestone');
        const totalSlides = $timelineLabels.length;

        // Utility functions
        const isMobile = () => window.innerWidth <= MOBILE_BREAKPOINT;

        const calculateProgressHeight = (index) => {
          const $activeSlide = $contentSlides.eq(index);
          const $container = $activeSlide.closest('.content-area');

          if (!$activeSlide.length || !$container.length) return 0;

          const containerRect = $container[0].getBoundingClientRect();
          const slideRect = $activeSlide[0].getBoundingClientRect();

          const containerTop = containerRect.top;
          const slideBottom = slideRect.bottom;
          const progressHeight = slideBottom - containerTop;
          const containerHeight = containerRect.height;

          return Math.min(Math.max((progressHeight / containerHeight) * 100, 0), 100);
        };

        const calculateDesktopProgress = (index) => {
          if (index === totalSlides - 1) return 100;
          const segmentWidth = 100 / totalSlides;
          return (index * segmentWidth) + (segmentWidth / 2);
        };

        const updateActiveStates = (index) => {
          $timelineLabels.removeClass('active');
          $timelineLabels.eq(index).addClass('active');
          $contentSlides.removeClass('active');
          $contentSlides.eq(index).addClass('active');
        };

        const refreshScrollTrigger = () => {
          if (typeof ScrollTrigger !== 'undefined') {
            setTimeout(() => ScrollTrigger.refresh(), SCROLL_TRIGGER_DELAY);
          }
        };

        const updateProgressLine = (index, progressPercent) => {
          if (isMobile()) {
            $timelineProgress.css({
              height: progressPercent + '%',
              width: '100%',
              transition: `height ${ANIMATION_DURATION}ms ease-out`
            });
          } else {
            $timelineProgress.css({
              width: progressPercent + '%',
              height: '100%',
              transition: `width ${ANIMATION_DURATION}ms ease-out`
            });
          }
        };

        // Main timeline update function
        const updateTimeline = (index = currentIndex) => {
          if (isMobile()) {
            const progressPercent = calculateProgressHeight(index);
            updateProgressLine(index, progressPercent);
          } else {
            const progressPercent = calculateDesktopProgress(index);
            updateProgressLine(index, progressPercent);
          }

          updateActiveStates(index);
          refreshScrollTrigger();
        };

        // Mobile click handler - only expand, no collapse
        const handleMobileClick = (e) => {
          e.stopPropagation();

          if (isAnimating) return;

          const $clickedSlide = $(e.currentTarget).closest('.content-slide');
          const slideIndex = $clickedSlide.index();

          if (slideIndex < 0 || slideIndex >= totalSlides) return;

          isAnimating = true;
          const $newSlide = $contentSlides.eq(slideIndex);
          const $clickedYear = $(e.currentTarget);

          // Update current index
          currentIndex = slideIndex;

          // Step 1: Expand the clicked slide
          $newSlide.addClass('active');
          updateActiveStates(currentIndex);

          // Step 2: Calculate scroll position after expansion
          setTimeout(() => {
            const targetScrollTop = $clickedYear.offset().top - HEADER_HEIGHT - VIEWPORT_OFFSET;

            // Smooth scroll to position
            window.scrollTo({
              top: targetScrollTop,
              behavior: 'smooth'
            });

            // Step 3: Update progress after scroll completes
            setTimeout(() => {
              const finalProgress = calculateProgressHeight(currentIndex);
              updateProgressLine(currentIndex, finalProgress);
              refreshScrollTrigger();
              isAnimating = false;
            }, 300);
          }, ANIMATION_DURATION);
        };

        // Desktop click handler
        const handleDesktopClick = function() {
          const yearIndex = parseInt($(this).data('year'));
          if (!isNaN(yearIndex) && yearIndex >= 0 && yearIndex < totalSlides) {
            currentIndex = yearIndex;
            updateTimeline();
          }
        };

        // Event handlers setup
        const setupEventHandlers = () => {
          if (isMobile()) {
            $contentSlides.off('click').on('click', '.content-year', handleMobileClick);
          } else {
            $timelineLabels.off('click').on('click', handleDesktopClick);
          }
        };

        // Resize handler
        const handleResize = () => {
          $timelineLabels.off('click');
          $contentSlides.off('click');
          setupEventHandlers();
          updateTimeline();
        };

        // ScrollTrigger setup
        const setupScrollTrigger = () => {
          if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
            gsap.registerPlugin(ScrollTrigger);

            ScrollTrigger.create({
              trigger: $section[0],
              start: "top center",
              // markers:true,
              onEnter: () => {
                currentIndex = 0;
                updateTimeline();
              },
              onEnterBack: () => {
                currentIndex = 0;
                updateTimeline();
              },
            });
          }
        };

        // Initialize
        setupEventHandlers();
        $(window).on('resize', handleResize);
        setupScrollTrigger();

        // Smooth mobile initialization
        if (isMobile()) {
          updateActiveStates(currentIndex);

          const initMobileProgress = () => {
            const initialProgressPercent = calculateProgressHeight(currentIndex);
            updateProgressLine(currentIndex, initialProgressPercent);
          };

          initMobileProgress();
          setTimeout(initMobileProgress, ANIMATION_DURATION + 100);
        } else {
          // updateTimeline();
        }
      }
    }

    // Khởi chạy khi DOM ready
    $(function() {
      About.init()
    })
  })(jQuery)
